import { ElasticSearchResponse, Handle, HandleDocument } from '@shared/services/elastic-search/models';

export const handlesSerializer = (handles: ElasticSearchResponse<HandleDocument>): Handle[] =>
  handles.hits.hits.map((handle) => {
    const source = handle._source;
    return {
      style: source.field_handle_style?.[0] ?? '',
      title: source.title?.[0] ?? '',
      styles: source.field_style_et_couleur.map((color) => {
        return {
          image: color.image,
          color: {
            name: color.rvb[0]?.name ?? '',
            rgb: color.rvb[0]?.rgb ?? `0,0,0`,
          },
        };
      }),
    };
  });
